import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Region } from '../model/region.model';
//import { Region } from 'src/app/component/common-components/location/model/region.model';
import { County } from '../model/county';
import { SchoolDistrict } from '../model/schoolDistrict.model';
import { School } from '../model/school.model';
import { Route, TrackingType } from '../model/session-tracking/tracking-type';
import { UserToken } from '../component/auth/model/user.model';
import { AuthService } from '../component/auth/service/auth.service';

@Injectable({
    providedIn: 'root'
})
export class HelperService {
    //All region store in memory used in District Data service need to refactor in the API
    private lstRegion = new BehaviorSubject<Region[]>([]);
    private lstUserProfileRegion = new BehaviorSubject<Region[]>([]);

    private selectedRegions = new BehaviorSubject<Region[]>([]);
    private selectedCounties = new BehaviorSubject<County[]>([]);
    private selectedDistrict = new BehaviorSubject<SchoolDistrict[]>([]);
    private selectedSchool = new BehaviorSubject<School[]>([]);
    private loadingSchools = new BehaviorSubject<boolean>(false);
    //Session Tracking Object
    private prevSessionTracking = new BehaviorSubject<TrackingType>(new TrackingType());
    private currSessionTracking = new BehaviorSubject<TrackingType>(new TrackingType());

    //Observable string Streams
    lstRegion$ = this.lstRegion.asObservable();

    lstUserProfileRegion$ = this.lstUserProfileRegion.asObservable();
    selectedRegions$ = this.selectedRegions.asObservable();
    selectedCounties$ = this.selectedCounties.asObservable();
    selectedDistrict$ = this.selectedDistrict.asObservable();
    selectedSchool$ = this.selectedSchool.asObservable();

    loadingSchools$ = this.loadingSchools.asObservable();

    //Session Tracking Object
    prevSessionTracking$ = this.prevSessionTracking.asObservable();
    currSessionTracking$ = this.currSessionTracking.asObservable();

    constructor(private authService: AuthService) {}

    setPrevSessionTracking(t: TrackingType) {
        this.prevSessionTracking.next(t);
    }

    setCurrSessionTracking(t: TrackingType) {
        const current = this.currSessionTracking.value;

        if (JSON.stringify(current) !== JSON.stringify(t)) {
            localStorage.setItem('trackingType', JSON.stringify(t));
            this.currSessionTracking.next(t);
        } else {
        }
    }

    addCurrSessionTrackingRoute(r: Route) {
        let currSessionTracking = this.getCurrentLocalStorageSessionTracking();

        if (!currSessionTracking.routes) {
            currSessionTracking.routes = [];
        }

        // Check latest route and inputRoute
        // Do not insert if inputRoute matches latest route and doesn't have search criterias
        if (currSessionTracking.routes.length > 0) {
            if (currSessionTracking.routes[currSessionTracking.routes.length - 1].path === r.path) {
                if (r.searchCriterias.length <= 0) {
                    return;
                }
            }
        }

        currSessionTracking.routes.push(r);

        this.setCurrSessionTracking(currSessionTracking);
        this.saveCurrSessionTracking()?.subscribe();
    }

    saveCurrSessionTracking() {
        const current = this.currSessionTracking.value;

        if (current.id && current.loginDetailId) {
            return this.authService.storeSessionTracking2(current);
        } else {
            return null;
        }
    }

    getCurrentLocalStorageSessionTracking(): TrackingType {
        return this.compareCurrentSessionTrackingWithCurrentUser();
    }

    compareCurrentSessionTrackingWithCurrentUser(): TrackingType {
        const sessionTrackingStr = localStorage.getItem('trackingType');
        const storedUserToken = localStorage.getItem('userToken');

        const sessionTracking = sessionTrackingStr ? (JSON.parse(sessionTrackingStr) as TrackingType) : null;
        const userToken = storedUserToken ? (JSON.parse(storedUserToken) as UserToken) : null;

        if (sessionTracking && userToken) {
            if (
                sessionTracking.id === userToken?.user?.LOGIN_AUDITS?.[0]?.ID?.toString() &&
                sessionTracking.loginDetailId === userToken?.user?.ID?.toString()
            ) {
                return sessionTracking;
            } else {
                return this.generateNewSessionTrackingForCurrentUser();
            }
        } else {
            return this.generateNewSessionTrackingForCurrentUser();
        }
    }

    generateNewSessionTrackingForCurrentUser() {
        let newTrackingType = new TrackingType();

        // Set ID to current sessionID
        const storedUserToken = localStorage.getItem('userToken');
        if (storedUserToken) {
            const userToken = JSON.parse(storedUserToken) as UserToken;

            if (userToken?.user?.LOGIN_AUDITS?.[0]?.ID) {
                newTrackingType = {
                    ...newTrackingType,
                    id: userToken?.user?.LOGIN_AUDITS?.[0]?.ID?.toString()
                };
            }
            if (userToken?.user?.ID) {
                newTrackingType = {
                    ...newTrackingType,
                    loginDetailId: userToken?.user?.ID?.toString()
                };
            }
            if (userToken?.user?.USER_ROLES?.[0]?.ROLE?.ID) {
                newTrackingType = {
                    ...newTrackingType,
                    roleId: userToken?.user?.USER_ROLES?.[0]?.ROLE?.ID
                };
            }
        }

        localStorage.setItem('trackingType', JSON.stringify(newTrackingType));
        return newTrackingType;
    }

    //All region
    setRegionListObject(r: Region[]) {
        this.lstRegion.next(r);
    }

    setUserProfileRegionObject(r: Region[]) {
        this.lstUserProfileRegion.next(r);
    }

    //selected Region
    setSelectedRegionObject(r: Region[]) {
        this.selectedRegions.next(r);
    }

    setSelectedCountyListObject(c: County[]) {
        this.selectedCounties.next(c);
    }

    setSelectedDistrictObject(d: SchoolDistrict[]) {
        this.selectedDistrict.next(d);
    }

    setSelectedSchoolListObject(d: School[]) {
        this.selectedSchool.next(d);
    }

    setLoadingSchools(loading: boolean) {
        this.loadingSchools.next(loading);
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    getCurrentPeriod() {
        const today = new Date();
        let currentYear: number;
        let previousYear: number;
        currentYear = today.getFullYear();
        previousYear = currentYear - 1;

        return previousYear.toString() + '-' + currentYear.toString().substring(2);
    }
}
